
export default class RandomNumberGenerator {
    constructor(private seed: number) {
        this.seed = this.seed % 2147483647;
        if (this.seed <= 0) {
            this.seed += 2147483646;
        }
    }

    public nextInt(min: number, max: number): number {
        return Math.floor(this.next() * (max - min + 1)) + min;
    }

    private next(): number {
        // Linear Congruential Generator (LCG) parameters
        const a: number = 16807;
        const m: number = 2147483647;
        const q: number = 127773;
        const r: number = 2836;

        const hi: number = Math.floor(this.seed / q);
        const lo: number = this.seed % q;
        const test: number = a * lo - r * hi;
        this.seed = test > 0 ? test : test + m;

        return this.seed / m;
    }
}